export const onZoomAnimState = {};
